import { Global } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import MainBanner from '../../components/MainBanner';
import SimpleContent from '../../components/SimpleContent';

export default function ContractorsPageSubmissionSuccess({
  global,
}) {
  return (
    <>
      <SeoHead
        page_name={`Thank you for applying | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG`}
        canonical_link={`jobs/thank-you-for-applying`}
        robots="noindex, follow"
      />
      <MainBanner
        global={global}
        pathPrefix={`jobs.thank_you_for_applying_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Application Success</h1>
          </>
        }
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
      />
      <SimpleContent
        global={global}
        pathPrefix={`jobs.thank_you_for_applying_page.simple_content`}
        customClass={`py-5 text-center`}
        content={
          <>
            <p>Your application has been successfully submitted.</p>
            <p>We will be in touch shortly!</p>
          </>}
        editableText={true}
        buttonTitle1={`Back to jobs`}
        buttonTitleLink1={`/jobs/`}
        buttonTitle2={`Business solutions`}
        buttonTitleLink2={`/employers/`}
      />
    </>
  )
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();

  return {
    props: {
      global,
    }
  };
}
